import React from "react";
import "./intro.css";
import { useLanguage } from "../LanguageContext/LanguageContext";

function Intro() {
  const { t } = useLanguage();

  return (
    <div className="intro">
      <p className="introTexth4">HK ISTANBUL Export</p>
      <p className="introTexth3">{t.intro}</p>
    </div>
  );
}

export default Intro;
